// extracted by mini-css-extract-plugin
export default {"message":"ErrorPages_message__ugaPw","description":"ErrorPages_description__f+0nf","mobile":"ErrorPages_mobile__gnnF1"};